<script setup lang="ts">
import  { type FilterInputSchema, FilterOperation } from '~/composables/simpleFilters'
import { BaseNumber, BaseSelect, BaseToggle } from '~/shared/model'

const props = withDefaults(
  defineProps<{
    modelValue: any[]
    availableFilters?: string[]
    item: FilterInputSchema
  }>(),
  {},
)
const emit =
  defineEmits<
    (
      e: 'update:modelValue',
      data: { operation: string; values: any | any[] },
    ) => void
  >()

const values = ref<Record<string, any>>(
  Object.values(FilterOperation).reduce(
    (acc, name) => ({
      ...acc,
      [name]:
        props.modelValue.find((item) => item.operation === name)?.values || [],
    }),
    {},
  ),
)
const baseOperations = [
  { label: 'Is', value: 'is' },
  { label: 'Is Not', value: 'is_not' },
  { label: 'Is Between', value: 'is_between' }
];

const stringOperations = [
  { label: 'Contains', value: 'contains' }
];

const numberOperations = [
  { label: 'Equal', value: 'eq' },
  { label: 'Greater Than', value: 'gt' },
  { label: 'Less Than', value: 'lt' },
  { label: 'Greater Than or Equal', value: 'gte' },
  { label: 'Less Than or Equal', value: 'lte' }
];

const booleanOperations = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' }
];

// const baseOperations = ['is', 'is_not', 'is_between']
// const stringOperations = ['contains']
// const numberOperations = ['eq', 'gt', 'lt', 'gte', 'lte']
// const booleanOperations = ['yes', 'no']
let operations =
  props.item instanceof BaseNumber
    ? numberOperations
    : props.item instanceof BaseSelect
    ? baseOperations
    : props.item instanceof BaseToggle
    ? booleanOperations
    : [...stringOperations, ...baseOperations]

if (props.availableFilters?.length) {
  operations = operations.filter(o => props.availableFilters.includes(o.value))
}
const selected = ref<string>(operations.at(0).value)
const submit = () => {
  emit('update:modelValue', {
    operation: selected.value,
    values: values.value[selected.value],
  })
}
</script>

<template>
  <div class="space-y-3 w-full">
    <div v-for="operation in operations" :key="operation.value">
      <Radio v-model="selected" :value="operation.value">
        <span
          class="text-sm ml-3"
          :class="{
            'font-semibold text-primary-600': selected === operation.value,
          }"
          >{{ operation.label }}</span
        >
      </Radio>
      <template v-if="selected === operation.value">
        <FormKit
          v-bind="{
            type: item.$formkit,
            canClear: item.canClear,
            initialOptions: item.initialOptions,
            options: item.options,
            where: item.where,
            mode: item.mode,
            placeholder: item.placeholder,
            delay: item.delay,
            disabled: item.disabled,
            filterResults: item.filterResults,
            keepValuesOnWatch: item.keepValuesOnWatch,
            resolveOnLoad: item.resolveOnLoad,
            searchable: item.searchable,
            showAddAll: item.showAddAll,
            view: item.view,
            component: item.component,
            props: item.props
          }"
          :ignore="true"
          :object="true"
          v-model="values[selected]"
          :classes="{
            outer: 'w-full mt-3 text-gray-400 focus-within:text-gray-600',
          }"
          v-if="item instanceof BaseSelect"
        />

        <div v-else-if="item instanceof BaseToggle" />
        <FormKit
          v-else
          v-model="values[selected]"
          :type="item.$formkit as any"
          :ignore="true"
          :placeholder="item.placeholder"
          :classes="{
            outer: 'w-full mt-3 text-gray-400 focus-within:text-gray-600',
          }"
        />
      </template>
    </div>
    <slot name="footer" :submit="submit" />
  </div>
</template>
